import { render, staticRenderFns } from "./PointListDepositLayout.vue?vue&type=template&id=30e07ba2&scoped=true&"
import script from "./PointListDepositLayout.vue?vue&type=script&lang=js&"
export * from "./PointListDepositLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e07ba2",
  null
  
)

export default component.exports